import { Controller } from "@hotwired/stimulus"

// Отправляет цель в Яндекс.Метрику, когда форма заявки успешно отправлена
// (партиал shared/_lead_success). Счётчик подключается только в production.
export default class extends Controller {
  static values = { goal: String }

  connect() {
    if (this.goalValue && window.ym && window.kibetMetrikaId) {
      window.ym(window.kibetMetrikaId, "reachGoal", this.goalValue)
    }
  }
}
